import { type LexicalEditor, $getSelection, $isRangeSelection } from 'lexical';
import { $convertToMarkdownString } from '@lexical/markdown';
import { TRANSFORMERS_LIST } from '../constants/transformers';

export const getEditorMarkdown = (editor: LexicalEditor) => {
  let markdown = '';

  editor.read(() => {
    markdown = $convertToMarkdownString(TRANSFORMERS_LIST);
  });

  return markdown;
};

export const getSelectedContent = (editor: LexicalEditor) => {
  let selectedText = '';
  editor.update(() => {
    const selection = $getSelection();
    if ($isRangeSelection(selection)) {
      selectedText = selection.getTextContent();
    }
  });

  return selectedText;
};
